import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  AlertPwa,
  MyAlertQueryQueryVariables,
  MyAlertQueryQuery
} from "../../../../schemaTypes";

export const myAlertQuery = gql`
  query MyAlertQuery(
    $offset: Int!
    $limit: Int!
  ) {
    myAlert(
      offset: $offset, 
      limit: $limit
    ) {
      id
      title
      update
      isSeen
      createdAt
      updatedAt
    }
  }
`;

export const newAlertSubscription = gql`
  subscription NewAlertSubscription {
    newAlert {
      id
      title
      update
      isSeen
      createdAt
      updatedAt
    }
  }
`;

export function useMyAlert(variables: MyAlertQueryQueryVariables) {
  const { data, loading, fetchMore, subscribeToMore } = useQuery<MyAlertQueryQuery, MyAlertQueryQueryVariables>(
    myAlertQuery,
    { variables }
  );

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newAlertSubscription,
      variables,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          myAlert: [
            ...prev.myAlert,
            (subscriptionData.data as any).newAlert
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore, variables]);

  const alert: AlertPwa[] = data?.myAlert ?? [];
  let hasMoreAlert = alert.length % variables.limit === 0;
  if (alert.length <= variables.offset) {
    hasMoreAlert = false;
  }

  const loadMore = () => {
    fetchMore({
      variables: {
        ...variables,
        offset: alert.length
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          ...prev,
          myAlert: [
            ...prev.myAlert,
            ...fetchMoreResult.myAlert
          ]
        };
      }
    });
  };

  return {
    alert,
    loading,
    loadMore,
    hasMoreAlert
  };
}